import { percentage, currency } from 'core-ui/plugins/CoreUiFilters'
import { DspAdvertisingSpendTypeOpts, PercentageSpendTypes } from '@/assets/js/constants/basisAdvertisingSpend'
import _get from 'lodash-es/get'

const adSpendCol = (keyPath, label, asCurrency = true) => {
  const getByDtoKey = (value, key, item) => _get(item, keyPath)
  const col = {
    label,
    key: keyPath.replaceAll('.', '-->'),
    sortByFormatted: getByDtoKey,
    filterByFormatted: getByDtoKey,
    thClass: 'text-right',
    sortable: true,
    filter: true,
    filterOptions: ['numeric']
  }

  if (asCurrency) {
    col.tdClass = 'font-numeric'
    col.formatter = (value, key, item) => (value ? currency(value, 2) : null)
  }

  return col
}

const basisAdvertiserSpendDefinitions = {
  basisAdSpendType: {
    ...adSpendCol('advertisingSpendDTO.spendType', 'Spend Type', false),
    // this will show all instead of existing. The alternative is defining this
    // directly within [manageType].
    filterOptions: [DspAdvertisingSpendTypeOpts]
  },
  basisAdSpendRate: {
    ...adSpendCol('advertisingSpendDTO.rate', 'Rate', false),
    tdClass: 'font-numeric',
    formatter: (value, key, item) => {
      if (!value) {
        return null
      }

      return PercentageSpendTypes.includes(item?.advertisingSpendDTO?.spendType) ? percentage(value / 100) : currency(value, 2)
    }
  },
  basisMaxBillable: adSpendCol('advertisingSpendDTO.maxBillable', 'Max Billable'),
  basisMarginOnAdvSpend: adSpendCol('metricsDTO.marginOnAdvSpend', 'Margin on Spend'),
  basisEffectiveCPM: adSpendCol('metricsDTO.advSpendeCPM', 'Effective CPM'),
  basisEffectiveCPC: adSpendCol('metricsDTO.advSpendeCPC', 'Effective CPC'),
  basisEffectiveCPA: adSpendCol('metricsDTO.advSpendeCPA', 'Effective CPA'),
  basisEffectiveCPCV: adSpendCol('metricsDTO.advSpendeCPCV', 'Effective CPCV')
}

export const basisAdvertiserSpendColumns = Object.keys(basisAdvertiserSpendDefinitions)
export default basisAdvertiserSpendDefinitions
